import {createApp} from "vue";
import App from "./App.vue";
import $ from "jquery";
import "jquery-ui/ui/widgets/datepicker";
import router from "./router";
import ElementPlus from 'element-plus'
import {CommonUtil} from "./js/commonUtil";
import {HttpUtil}from './js/httpUtil';

import "./js/perfect-scrollbar.min.js";
import 'element-plus/dist/index.css';


//グローバルスコープに設定
window.$ = $;

// if (process.env.NODE_ENV === 'development') {
//     const { worker } = require('./mocks/browser.js')
//     worker.start()
// }

const app = createApp(App)

//commonUtilをグローバル化
app.config.globalProperties.$commonUtil = CommonUtil;

//HttpUtilをグローバル化
app.config.globalProperties.$httpUtil = HttpUtil;

app.use(router);
app.use(HttpUtil);
app.use(ElementPlus);
app.mount("#app");
